
export const getFavoriteTracksNextPage = state => state.favorite.tracks.nextPage;